import * as React from 'react';
import { useEndSession } from 'hooks/useEndSession';
import { MultiVoipProps } from './MultiVoip';
import MultiVoipInternal from './MultiVoipInternal';

const MultiVoipWithRouting: React.FC<MultiVoipProps> = ({
  controls,
  className,
  onActiveSpeakerChange,
  onActiveParticipantChange,
  onSelfMirrorChange,
  extraControls,
  maxParticipants,
}) => {
  const onEndSession = useEndSession();

  return (
    <MultiVoipInternal
      controls={controls}
      className={className}
      onEndSession={onEndSession}
      onActiveSpeakerChange={onActiveSpeakerChange}
      onActiveParticipantChange={onActiveParticipantChange}
      onSelfMirrorChange={onSelfMirrorChange}
      extraControls={extraControls}
      maxParticipants={maxParticipants}
    />
  );
};

export default MultiVoipWithRouting;
